<template>
  <div class="bottom_btn_container">{{ title }}</div>
</template>

<script>
export default {
  name: 'bottom-btn',
  props: ['title']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .bottom_btn_container {
    max-width: 640px;
    height: rem(75);
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: rem(28);
    font-weight: bold;
    background: #ff9500;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
